<template>
  <header class="tw-flex tw-justify-between tw-text-[#b3b9c6]">
    <span class="tw-font-georgia">
      {{ analysisDate }}
    </span>
    <span class="tw-font-poppins">
      Investment Proposal
    </span>
  </header>
</template>
<script>
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
export default {
  name: 'ReturnsMethodology',
  props: ['displayType', 'portfolio', 'benchmark'],
  computed: {
    ...mapStores(useCheckupStore),
    analysisDate() {
      let date = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
      if (this.checkupStore.portfolio_checkup_created_date) {
        const createdDate = new Date(this.checkupStore.portfolio_checkup_created_date);
        if (!isNaN(createdDate)) { // Ensure it's a valid date
          date = createdDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
        }
      }
      return date;
    },
  },
}
</script>
